export const getBrandMonitoringContent = () => ({
  metaTitle: `brand-monitoring.brand-protection-meta-title`,
  metaDescription: `brand-monitoring.brand-protection-meta-desc`,
})

export const getBrandMonitoringFormContent = () => ({
  metaTitle: 'brand-monitoring.meta-title',
  metaDescription: 'brand-monitoring.meta-desc',
})
